export namespace PaymentTypes {

    export const PaymentType = Symbol("PaymentType");
    export interface PaymentType {
        [PaymentType]: boolean;
    }

    export interface PaymentTypeDto {
        $type: string;
        value: PaymentTypeValueDto;
    }

    export interface PaymentTypeValueDto {
        //
    }

    export function serializePaymentType(action: PaymentType): PaymentTypeDto {
        if (!action) {
            return null;
        }

        for (let paymentType of paymentTypes) {
            if (paymentType.isInstanceOf(action)) {
                return {
                    $type: paymentType.key,
                    value: paymentType.serialize(action)
                };
            }
        }

        throw new Error("Invalid status type");
    }

    export function deserializePaymentType(dto: PaymentTypeDto): PaymentType {
        if (!dto) {
            return null;
        }

        for (let paymentType of paymentTypes) {
            if (paymentType.key === dto.$type) {
                return paymentType.deserialize(dto.value);
            }
        }

        throw new Error("Invalid status type");
    }

    export function getPaymentTypeName(status: PaymentType): string {

        for (let paymentType of paymentTypes) {
            if (paymentType.isInstanceOf(status)) {
                return paymentType.name;
            }
        }

        throw new Error("Invalid status type");
    }

    export function createPaymentType(key: string): PaymentType {

        for (let paymentType of paymentTypes) {
            if (paymentType.key === key) {
                return paymentType.create();
            }
        }

        throw new Error("Invalid paymentType key");
    }



    export const CreditPaymentType = Symbol("CreditPaymentType");
    export interface CreditPaymentType extends PaymentType {
        [CreditPaymentType]: boolean;
        CreditId: string;
    }

    export function isCreditPaymentType(val: PaymentType): val is CreditPaymentType {
        return val && (val as CreditPaymentType)[CreditPaymentType] === true;
    }

    export interface CreditPaymentTypeValueDto extends PaymentTypeValueDto {
        creditId: string;
    }

    export const CreditPaymentTypeDefinition: PaymentTypeDefinitionT<CreditPaymentType, CreditPaymentTypeValueDto> =
    {
        key: "Credit",
        name: "Credit",
        isInstanceOf: (paymentType: PaymentType) => isCreditPaymentType(paymentType),
        create: (): CreditPaymentType => {
            return {
                [PaymentType]: true,
                [CreditPaymentType]: true,
                CreditId: null
            };
        },
        serialize: (paymentType: CreditPaymentType): CreditPaymentTypeValueDto => {
            return {
                creditId: paymentType.CreditId
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: CreditPaymentTypeValueDto) {
            const credit = this.create() as CreditPaymentType;
            credit.CreditId = dto.creditId;
            return credit;
        }
    };


    export const StripePaymentType = Symbol("StripePaymentType");
    export interface StripePaymentType extends PaymentType {
        [StripePaymentType]: boolean;
        FeeAmount: number;
    }

    export function isStripePaymentType(val: PaymentType): val is StripePaymentType {
        return val && (val as StripePaymentType)[StripePaymentType] === true;
    }

    export interface StripePaymentTypeValueDto extends PaymentTypeValueDto {
        feeAmount: number;
    }

    export const StripePaymentTypeDefinition: PaymentTypeDefinition = {
        key: "Stripe",
        name: "Stripe",
        isInstanceOf: (paymentType: PaymentType) => isStripePaymentType(paymentType),
        create: (): StripePaymentType => {
            return {
                [PaymentType]: true,
                [StripePaymentType]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentType: StripePaymentType): StripePaymentTypeValueDto => {
            return {
                feeAmount: paymentType.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: StripePaymentTypeValueDto) {
            const stripe = this.create() as StripePaymentType;
            stripe.FeeAmount = dto.feeAmount;
            return stripe;
        }
    };


    export const OmisePaymentType = Symbol("OmisePaymentType");
    export interface OmisePaymentType extends PaymentType {
        [OmisePaymentType]: boolean;
        FeeAmount: number;
    }

    export function isOmisePaymentType(val: PaymentType): val is OmisePaymentType {
        return val && (val as OmisePaymentType)[OmisePaymentType] === true;
    }

    export interface OmisePaymentTypeValueDto extends PaymentTypeValueDto {
        feeAmount: number;
    }

    export const OmisePaymentTypeDefinition: PaymentTypeDefinition = {
        key: "Omise",
        name: "Omise",
        isInstanceOf: (paymentType: PaymentType) => isOmisePaymentType(paymentType),
        create: (): OmisePaymentType => {
            return {
                [PaymentType]: true,
                [OmisePaymentType]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentType: OmisePaymentType): OmisePaymentTypeValueDto => {
            return {
                feeAmount: paymentType.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: OmisePaymentTypeValueDto) {
            const omise = this.create() as OmisePaymentType;
            omise.FeeAmount = dto.feeAmount;
            return omise;
        }
    };



    export const TwoC2PPaymentType = Symbol("TwoC2PPaymentType");
    export interface TwoC2PPaymentType extends PaymentType {
        [TwoC2PPaymentType]: boolean;
        FeeAmount: number;
    }

    export function isTwoC2PPaymentType(val: PaymentType): val is TwoC2PPaymentType {
        return val && (val as TwoC2PPaymentType)[TwoC2PPaymentType] === true;
    }

    export interface TwoC2PPaymentTypeValueDto extends PaymentTypeValueDto {
        feeAmount: number;
    }

    export const TwoC2PPaymentTypeDefinition: PaymentTypeDefinition = {
        key: "TwoC2P",
        name: "2C2P",
        isInstanceOf: (paymentType: PaymentType) => isTwoC2PPaymentType(paymentType),
        create: (): TwoC2PPaymentType => {
            return {
                [PaymentType]: true,
                [TwoC2PPaymentType]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentType: TwoC2PPaymentType): TwoC2PPaymentTypeValueDto => {
            return {
                feeAmount: paymentType.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: TwoC2PPaymentTypeValueDto) {
            const twoC2P = this.create() as TwoC2PPaymentType;
            twoC2P.FeeAmount = dto.feeAmount;
            return twoC2P;
        }
    };



    export const WisePaymentType = Symbol("WisePaymentType");
    export interface WisePaymentType extends PaymentType {
        [WisePaymentType]: boolean;
        FeeAmount: number;
    }

    export function isWisePaymentType(val: PaymentType): val is WisePaymentType {
        return val && (val as WisePaymentType)[WisePaymentType] === true;
    }

    export interface WisePaymentTypeValueDto extends PaymentTypeValueDto {
        feeAmount: number;
    }

    export const WisePaymentTypeDefinition: PaymentTypeDefinition = {
        key: "Wise",
        name: "Wise",
        isInstanceOf: (paymentType: PaymentType) => isWisePaymentType(paymentType),
        create: (): WisePaymentType => {
            return {
                [PaymentType]: true,
                [WisePaymentType]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentType: WisePaymentType): WisePaymentTypeValueDto => {
            return {
                feeAmount: paymentType.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: WisePaymentTypeValueDto) {
            const wise = this.create() as WisePaymentType;
            wise.FeeAmount = dto.feeAmount;
            return wise;
        }
    };





    export const CreditCardPaymentType = Symbol("CreditCardPaymentType");
    export interface CreditCardPaymentType extends PaymentType {
        [CreditCardPaymentType]: boolean;
    }

    export function isCreditCardPaymentType(val: PaymentType): val is CreditCardPaymentType {
        return val && (val as CreditCardPaymentType)[CreditCardPaymentType] === true;
    }

    export interface CreditCardPaymentTypeValueDto extends PaymentTypeValueDto {
        //
    }

    const CreditCardPaymentTypeDefinition: PaymentTypeDefinition = {
        key: "CreditCard",
        name: "Credit Card",
        isInstanceOf: (paymentType: PaymentType) => isCreditCardPaymentType(paymentType),
        create: (): CreditCardPaymentType => {
            return {
                [PaymentType]: true,
                [CreditCardPaymentType]: true,
            };
        },
        serialize: (paymentType: CreditCardPaymentType): CreditCardPaymentTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: CreditCardPaymentTypeValueDto) {
            const creditCard = this.create() as CreditCardPaymentType;
            return creditCard;
        }
    };





    export const CashPaymentType = Symbol("CashPaymentType");
    export interface CashPaymentType extends PaymentType {
        [CashPaymentType]: boolean;
    }

    export function isCashPaymentType(val: PaymentType): val is CashPaymentType {
        return val && (val as CashPaymentType)[CashPaymentType] === true;
    }

    export interface CashPaymentTypeValueDto extends PaymentTypeValueDto {
        //
    }

    const CashPaymentTypeDefinition: PaymentTypeDefinition = {
        key: "Cash",
        name: "Cash",
        isInstanceOf: (paymentType: PaymentType) => isCashPaymentType(paymentType),
        create: (): CashPaymentType => {
            return {
                [PaymentType]: true,
                [CashPaymentType]: true,
            };
        },
        serialize: (paymentType: CashPaymentType): CashPaymentTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: CashPaymentTypeValueDto) {
            const creditCard = this.create() as CashPaymentType;
            return creditCard;
        }
    };



    export const KrungsriPaymentType = Symbol("KrungsriPaymentType");
    export interface KrungsriPaymentType extends PaymentType {
        [KrungsriPaymentType]: boolean;
    }

    export function isKrungsriPaymentType(val: PaymentType): val is KrungsriPaymentType {
        return val && (val as KrungsriPaymentType)[KrungsriPaymentType] === true;
    }

    export interface KrungsriPaymentTypeValueDto extends PaymentTypeValueDto {
        //
    }

    const KrungsriPaymentTypeDefinition: PaymentTypeDefinition = {
        key: "Krungsri",
        name: "Krungsri",
        isInstanceOf: (paymentType: PaymentType) => isKrungsriPaymentType(paymentType),
        create: (): KrungsriPaymentType => {
            return {
                [PaymentType]: true,
                [KrungsriPaymentType]: true,
            };
        },
        serialize: (paymentType: KrungsriPaymentType): KrungsriPaymentTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: KrungsriPaymentTypeValueDto) {
            const creditCard = this.create() as KrungsriPaymentType;
            return creditCard;
        }
    };


    export const SCBPaymentType = Symbol("SCBPaymentType");
    export interface SCBPaymentType extends PaymentType {
        [SCBPaymentType]: boolean;
    }

    export function isSCBPaymentType(val: PaymentType): val is SCBPaymentType {
        return val && (val as SCBPaymentType)[SCBPaymentType] === true;
    }

    export interface SCBPaymentTypeValueDto extends PaymentTypeValueDto {
        //
    }

    const SCBPaymentTypeDefinition: PaymentTypeDefinition = {
        key: "SCB",
        name: "Bank Transfer - SCB",
        isInstanceOf: (paymentType: PaymentType) => isSCBPaymentType(paymentType),
        create: (): SCBPaymentType => {
            return {
                [PaymentType]: true,
                [SCBPaymentType]: true,
            };
        },
        serialize: (paymentType: SCBPaymentType): SCBPaymentTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: SCBPaymentTypeValueDto) {
            const creditCard = this.create() as SCBPaymentType;
            return creditCard;
        }
    };


    export const VoucherPaymentType = Symbol("VoucherPaymentType");
    export interface VoucherPaymentType extends PaymentType {
        [VoucherPaymentType]: boolean;
    }

    export function isVoucherPaymentType(val: PaymentType): val is VoucherPaymentType {
        return val && (val as VoucherPaymentType)[VoucherPaymentType] === true;
    }

    export interface VoucherPaymentTypeValueDto extends PaymentTypeValueDto {
        //
    }

    const VoucherPaymentTypeDefinition: PaymentTypeDefinition = {
        key: "Voucher",
        name: "Voucher",
        isInstanceOf: (paymentType: PaymentType) => isVoucherPaymentType(paymentType),
        create: (): VoucherPaymentType => {
            return {
                [PaymentType]: true,
                [VoucherPaymentType]: true,
            };
        },
        serialize: (paymentType: VoucherPaymentType): VoucherPaymentTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: VoucherPaymentTypeValueDto) {
            const voucher = this.create() as VoucherPaymentType;
            return voucher;
        }
    };


    export const AdjustmentPaymentType = Symbol("AdjustmentPaymentType");
    export interface AdjustmentPaymentType extends PaymentType {
        [AdjustmentPaymentType]: boolean;
    }

    export function isAdjustmentPaymentType(val: PaymentType): val is AdjustmentPaymentType {
        return val && (val as AdjustmentPaymentType)[AdjustmentPaymentType] === true;
    }

    export interface AdjustmentPaymentTypeValueDto extends PaymentTypeValueDto {
        //
    }

    const AdjustmentPaymentTypeDefinition: PaymentTypeDefinition = {
        key: "Adjustment",
        name: "Adjustment",
        isInstanceOf: (paymentType: PaymentType) => isAdjustmentPaymentType(paymentType),
        create: (): AdjustmentPaymentType => {
            return {
                [PaymentType]: true,
                [AdjustmentPaymentType]: true,
            };
        },
        serialize: (paymentType: AdjustmentPaymentType): AdjustmentPaymentTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: PaymentTypeDefinition, dto: AdjustmentPaymentTypeValueDto) {
            const adjustment = this.create() as AdjustmentPaymentType;
            return adjustment;
        }
    };



    interface PaymentTypeDefinition {
        key: string;
        name: string;
        isInstanceOf: (paymentType: PaymentType) => boolean;
        create: () => PaymentType;
        serialize: (paymentType: PaymentType) => PaymentTypeValueDto;
        deserialize: (dto: PaymentTypeValueDto) => PaymentType;
    }

    interface PaymentTypeDefinitionT<T, TDto> extends Omit<PaymentTypeDefinition, 'create' | 'serialize' | 'deserialize'> {
        create: () => T;
        serialize: (paymentType: T) => TDto;
        deserialize: (dto: TDto) => T;
    }

    const paymentTypes: PaymentTypeDefinition[] = [
        CreditPaymentTypeDefinition,
        StripePaymentTypeDefinition,
        OmisePaymentTypeDefinition,
        TwoC2PPaymentTypeDefinition,
        WisePaymentTypeDefinition,
        CreditCardPaymentTypeDefinition,
        CashPaymentTypeDefinition,
        KrungsriPaymentTypeDefinition,
        SCBPaymentTypeDefinition,
        AdjustmentPaymentTypeDefinition,
        VoucherPaymentTypeDefinition
    ]

}
